import React from "react";
import Header from "../Home/Header";
import Footer from "../Home/Footer";
import Map from "./Map";
import ContactUs2 from "./ContactUs2";
import { Helmet, HelmetProvider } from "react-helmet-async";

const ContactUs = () => {
  return (
    <>
      <HelmetProvider>
        <div>
          <Helmet>
            {/* Google tag (gtag.js) */}
            <script
              async
              src="https://www.googletagmanager.com/gtag/js?id=AW-17221532514"
            ></script>
            <script>
              {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'AW-17221532514');
          `}
            </script>
          </Helmet>
        </div>
      </HelmetProvider>
      <Header />
      <ContactUs2 />
      <Map />
      <Footer />
    </>
  );
};

export default ContactUs;
